import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { DoubleHeroStoryblok } from "~/generated/sb/blok-types";
import styles from "./DoubleHeroBlok.module.css";

export const DoubleHeroBlok = ({ blok, preview }: BlokProps<DoubleHeroStoryblok>) => {
	return (
		<BlokWrap editable={blok} className={styles.root} data-layout="blok">
			{blok.slides.map((slide) => {
				return (
					<div className={styles.slide} key={slide._uid}>
						<StoryblokComponent blok={slide} slides={blok.slides.length} preview={preview} />
					</div>
				);
			})}
		</BlokWrap>
	);
};
